import React, { PureComponent } from 'react'

class Footer extends PureComponent {
  render() {
    return (
      <footer>
        &copy;{new Date().getFullYear()} ClubHub <br /> All Rights Reserved{' '}
        <br /> v.{' '}
        {document.head.querySelector('meta[name="build-version"]')['content']}
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Bone/Footer.js